import { Select, Space } from "antd";
import { FC, ReactNode, useState } from "react";
import styles from "./CustomSelect.module.scss";

type ItemWithId = {
  id: string | number;
  name: string | number;
};

type ItemType = string | number;

interface CustomSelectProps {
  items: ItemWithId[] | ItemType[];
  handleChange?: (value: string) => void;
  handleBlur?: () => void;
  handleClick?: () => void;
  handleDeselect?: () => void;
  placeholder?: string | null;
  multiple?: boolean;
  fieldValue?: string | string[] | null | undefined;
  allowClear?: boolean;
  showSearch?: boolean;
  disabled?: boolean;
  maxTagCount?: number;
  maxTagPlaceholder?: ReactNode;
  loading?: boolean;
  dataTestId?: string;
}

export const CustomSelect: FC<CustomSelectProps> = ({
  items,
  placeholder = null,
  handleChange,
  handleBlur,
  handleDeselect,
  handleClick,
  multiple = false,
  fieldValue,
  allowClear = false,
  showSearch = true,
  disabled = false,
  maxTagCount,
  maxTagPlaceholder,
  loading = false,
  dataTestId,
}) => {
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const filterOption = (
    input: string,
    option?: { label: string | number; value: string | number },
  ) =>
    (option?.label ?? "")
      .toString()
      .toLowerCase()
      .includes(input.toLowerCase());
  type SelectData = { label: string | number; value: string | number };

  const data = items.reduce((acc, item) => {
    if (typeof item === "object") {
      acc.push({
        label: item.name,
        value: item.id,
      });
    } else {
      acc.push({
        label: item,
        value: item,
      });
    }

    return acc;
  }, [] as SelectData[]);

  return (
    <div className={styles.selectWrapper}>
      <Space style={{ width: "100%" }} direction="vertical">
        <Select
          data-testid={dataTestId}
          onDropdownVisibleChange={setDropdownVisible}
          mode={multiple ? "multiple" : undefined}
          showSearch={showSearch}
          placeholder={placeholder || "Выберите из списка"}
          optionFilterProp="children"
          onChange={handleChange}
          onBlur={handleBlur}
          onClick={handleClick}
          filterOption={filterOption}
          options={data}
          defaultValue={fieldValue ? fieldValue : undefined}
          onDeselect={!dropdownVisible && handleDeselect}
          allowClear={allowClear}
          disabled={disabled}
          maxTagCount={maxTagCount >= 0 ? maxTagCount : "responsive"}
          maxTagPlaceholder={maxTagPlaceholder ? maxTagPlaceholder : undefined}
          loading={loading}
        />
      </Space>
    </div>
  );
};
